import LibUtils from "lib/LibUtils";
import React, { useState } from "react";
import { NumberFormatBase, NumberFormatBaseProps } from "react-number-format";
import { ChangeMeta } from "react-number-format/types/types";

////////////////////////////////////////////////////////////////////////////

interface NumberFormatInputProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    locale: string;
    currentValue?: number;
}

////////////////////////////////////////////////////////////////////////////

export const CurrencyFormatInput = React.forwardRef<NumberFormatBaseProps, NumberFormatInputProps>(function NumberFormatCustom(props, ref) {

    const { onChange, locale, currentValue, ...rest } = props;
    const numberSeparators = LibUtils.getLocaleNumberSeparators(locale);

    const [internalValue, setInternalValue] = useState<string>(String(Number(currentValue ?? 0) * 100));

    ////////////////////////////////////////////////////////////////////////////
    ///
    const formatCurrency = (inputValue: string) => {
        if (!Number(inputValue)) return "";

        const amount = new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2,
        }).format(Number(inputValue) / 100);

        return `${amount}`;
    };

    ///
    const removeCurrencyFormat = ((inputValue: string, changeMeta?: ChangeMeta) => {
        return inputValue
            .replace(new RegExp('\\' + numberSeparators.decimalSeparator, 'g'), "")
            .replace(new RegExp('\\' + numberSeparators.thousandSeparator, 'g'), "");
    });

    ////////////////////////////////////////////////////////////////////////////

    return (
        <NumberFormatBase
            {...rest}
            value={internalValue}
            getInputRef={ref}
            onValueChange={(values) => {
                setInternalValue(values.value);
                onChange({
                    target: {
                        name: props.name,
                        value: String(Number(values.value) / 100)
                    }
                });
            }}
            valueIsNumericString
            format={formatCurrency}
            removeFormatting={removeCurrencyFormat}
            getCaretBoundary={() => [false]}
        />
    );
});
